import { render, staticRenderFns } from "./PictureInput.vue?vue&type=template&id=f97b8cb2&"
import script from "./PictureInput.vue?vue&type=script&lang=js&"
export * from "./PictureInput.vue?vue&type=script&lang=js&"
import style0 from "./PictureInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports